import React, { useEffect } from 'react';
import '../../styles/legal.css';

const Refund: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        
        <div className="legal-header">
          <h1 className="legal-title">Refund Policy</h1>
          <p className="legal-subtitle">Last updated: May 10, 2026</p>
        </div>

        <div className="legal-content">
          <p>The refunds in accordance with our return guidelines shall be as per the following:</p>
          <ul>
            <li>In case of pre-paid order, the refund will be processed through payment gateway or any other online banking / electronic funds transfer system approved by Reserve Bank India and will reflect in same account of customer buying the Product from where customer has paid the transaction amount.</li>
            <li>For cash on delivery transactions, refunds, if any, will be made via demand draft/NEFT/Cheque etc. in favour of the customer buying the Products, as per the details provided by the customer.</li>
            <li>The customer buying the Products will not be charged for the pickup, and no other deductions shall be made on refunds confirmed to the customer buying the Product.</li>
          </ul>
          
          <h2>Refunds / Returns shall NOT be allowed in the following cases:</h2>
          <ul>
            <li>Return request is made outside the specified time frame of 48 (Forty-Eight) hours as specified in our return policy.</li>
            <li>In case where price tags, labels, original packing, freebies and accessories, box are missing.</li>
            <li>If the Product is damaged by the customer, in any manner as may be determined by Industrybull at its sole discretion.</li>
            <li>If Product has been used by the customer.</li>
            <li>If Product sold as combo/sets cannot be returned as individual Product.</li>
          </ul>

          <h2>I've still not received the refund to my bank account. Why?</h2>
          <p>If you have received a mail/message from us confirming your refund request then rest assured that we have initiated your refund request and are following up with financial organisations for the same.</p>
          <p>Sometimes financial organisations take a longer time to process the refund request. However, if the refund hasn't happened by the date we promised, you can contact us. We will gladly help you.</p>

          <h2>When are Refunds provided?</h2>
          <p>We work to provide the most hassle-free online shopping experience. You are covered and your money safe. We initiate the refund process as soon as we receive the details.</p>
          <ul>
            <li>Damaged products are returned to our warehouse and has been quality checked.</li>
          </ul>

          <h2>I paid the amount upfront while purchasing product from Industrybull, how do I get the refund?</h2>
          <p>Your payment is secured. In case of prepaid orders (paid through credit card/debit card/net banking), the amount is refunded in the same account as you had made payment from within 7-10 working days.</p>

          <h2>I paid cash on delivery, how would I get the refund?</h2>
          <p>If the mode of payment was cash on delivery (COD), we will initiate a NEFT bank transfer to your bank account. Industrybull will contact you for your bank account details. It normally takes 7-10 days for your money to get reflected in your bank account.</p>

          <h2>What are the details you require to process NEFT refund?</h2>
          <p>Once you agree for NEFT refund, you will receive an email from Industrybull customer support team asking for:</p>
          <ul>
            <li>Bank Name</li>
            <li>Account Number</li>
            <li>Account Holder’s name</li>
            <li>IFSC code</li>
            <li>Location of the Bank</li>
          </ul>
          <p>We initiate refund process as soon as we receive the details from you and it takes 7-10 working days for the money to be credited to your account.</p>

          <h2>Can I ask for NEFT refund if I paid through Credit Card/Debit Card/Net banking?</h2>
          <p>No, in case you paid via credit card/debit card/net banking, the amount will be refunded in the same account as you had made payment from.</p>

          <h2>How long will it take to refund?</h2>
          <p>It takes 7-10 working days for the money to be credited to your account.</p>
        </div>

      </div>
    </div>
  );
};

export default Refund;
